/** Persisted UI locale for the customer PWA shell (cs | en | sk). */
export const CUSTOMER_LOCALE_STORAGE_KEY = 'rpapp-customer-locale';

export type CustomerSupportedLocale = 'cs' | 'en' | 'sk';

export function readStoredCustomerLocale(): CustomerSupportedLocale | null {
  if (typeof window === 'undefined' || typeof window.localStorage === 'undefined') {
    return null;
  }
  try {
    const raw = window.localStorage.getItem(CUSTOMER_LOCALE_STORAGE_KEY);
    if (raw === 'cs' || raw === 'en' || raw === 'sk') {
      return raw;
    }
    return null;
  } catch {
    return null;
  }
}

export function writeStoredCustomerLocale(locale: CustomerSupportedLocale): void {
  if (typeof window === 'undefined' || typeof window.localStorage === 'undefined') {
    return;
  }
  try {
    window.localStorage.setItem(CUSTOMER_LOCALE_STORAGE_KEY, locale);
  } catch {
    // Quota or private mode — ignore
  }
}
